module.exports = __webpack_public_path__ + "static/LOGO 6-4f2f35cd93dc8c85fccdfe9fc54f5bce.png";